import times from 'lodash/times';
import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import {
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '../../../../../../../../CommonComponents/OPL/Table/Table';
import { TextLoading } from '../../../../../../../../CommonComponents/OPL/Text/Text.loading';

export const AssetAllocationLoading = () => {
  return (
    <>
      <Box py="16" maxWidth="50%">
        <Shimmer height={12} />
        <Shimmer height={36} mt="4" />
      </Box>
      <Box py="16">
        <Shimmer height={12} />
        <Shimmer height={32} mt="16" />
      </Box>

      <TableHeader css="margin: 0 -24px">
        <TableRow px="24">
          <TableCell flex={1}>&nbsp;</TableCell>
        </TableRow>
      </TableHeader>

      <TableBody
        overflowY="auto"
        maxHeight={265}
        css="margin: 0 -24px"
        borderBottom="1px solid"
        borderColor="neutral.200"
      >
        {times(5).map(key => (
          <TableRow key={key} px="24">
            <TableCell flex={1}>
              <Shimmer height={24} width={24} mr="4" />

              <TextLoading width={50} />
            </TableCell>
            <TableCell width={94} flex="0 0 auto">
              <Shimmer height={36} width={100} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>

      <Box display="flex" justifyContent="space-between" mt="16">
        <Shimmer height={24} width={200} />

        <Shimmer height={24} width={80} />
      </Box>
    </>
  );
};
